/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NotLoggedInRouteImport } from './routes/not-logged-in'
import { Route as OrganizationKeyDossierIdRouteImport } from './routes/$organizationKey.$dossierId'
import { Route as OrganizationKeyDossierIdIndexRouteImport } from './routes/$organizationKey.$dossierId/index'
import { Route as OrganizationKeyDossierIdAnnouncementsRouteImport } from './routes/$organizationKey.$dossierId/announcements'
import { Route as OrganizationKeyDossierIdLab_test_resultsRouteImport } from './routes/$organizationKey.$dossierId/lab_test_results'
import { Route as OrganizationKeyDossierIdMeasureRouteImport } from './routes/$organizationKey.$dossierId/measure'
import { Route as OrganizationKeyDossierIdPendingRouteImport } from './routes/$organizationKey.$dossierId/pending'
import { Route as OrganizationKeyDossierIdPreferencesRouteImport } from './routes/$organizationKey.$dossierId/preferences'
import { Route as OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRouteImport } from './routes/$organizationKey.$dossierId/self_initiable_measured_questionnaires'
import { Route as OrganizationKeyDossierIdDesignIndexRouteImport } from './routes/$organizationKey.$dossierId/design/index'
import { Route as OrganizationKeyDossierIdDesignColorsRouteImport } from './routes/$organizationKey.$dossierId/design/colors'
import { Route as OrganizationKeyDossierIdDesignComponentsRouteImport } from './routes/$organizationKey.$dossierId/design/components'
import { Route as OrganizationKeyDossierIdDesignFormsRouteImport } from './routes/$organizationKey.$dossierId/design/forms'
import { Route as OrganizationKeyDossierIdDossierIndexRouteImport } from './routes/$organizationKey.$dossierId/dossier/index'
import { Route as OrganizationKeyDossierIdDossierDemographicsRouteImport } from './routes/$organizationKey.$dossierId/dossier/demographics'
import { Route as OrganizationKeyDossierIdDossierMetadataRouteImport } from './routes/$organizationKey.$dossierId/dossier/metadata'
import { Route as OrganizationKeyDossierIdNotificationsNewRouteImport } from './routes/$organizationKey.$dossierId/notifications.new'
import { Route as OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteImport } from './routes/$organizationKey.$dossierId/outcome.$questionnaireId'
import { Route as OrganizationKeyDossierIdProtocol_subscriptionsIndexRouteImport } from './routes/$organizationKey.$dossierId/protocol_subscriptions.index'
import { Route as OrganizationKeyDossierIdProtocol_subscriptionsStoppedRouteImport } from './routes/$organizationKey.$dossierId/protocol_subscriptions.stopped'
import { Route as OrganizationKeyDossierIdQuestionnairesIndexRouteImport } from './routes/$organizationKey.$dossierId/questionnaires.index'
import { Route as OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRouteImport } from './routes/$organizationKey.$dossierId/fill_out_wizard.$measurementId.create_direct'
import { Route as OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRouteImport } from './routes/$organizationKey.$dossierId/fill_out_wizard.$measurementId.create_fill_out_request'
import { Route as OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRouteImport } from './routes/$organizationKey.$dossierId/fill_out_wizard.$measurementId.create_fill_out_session'
import { Route as OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRouteImport } from './routes/$organizationKey.$dossierId/fill_out_wizard.$measurementId.create_non_response'
import { Route as OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRouteImport } from './routes/$organizationKey.$dossierId/fill_out_wizard.$measurementId.create_self_initiable_measured_questionnaires'
import { Route as OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRouteImport } from './routes/$organizationKey.$dossierId/fill_out_wizard_new.$measurementId.choose'
import { Route as OrganizationKeyDossierIdNon_responsesShowNonResponseIdRouteImport } from './routes/$organizationKey.$dossierId/non_responses.show.$nonResponseId'
import { Route as OrganizationKeyDossierIdNotificationsShowNotificationIdRouteImport } from './routes/$organizationKey.$dossierId/notifications.show.$notificationId'
import { Route as OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRouteImport } from './routes/$organizationKey.$dossierId/outcome.$questionnaireId.answers'
import { Route as OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRouteImport } from './routes/$organizationKey.$dossierId/outcome.$questionnaireId.charts'
import { Route as OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRouteImport } from './routes/$organizationKey.$dossierId/outcome.$questionnaireId.help'
import { Route as OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRouteImport } from './routes/$organizationKey.$dossierId/outcome.$questionnaireId.scores'
import { Route as OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRouteImport } from './routes/$organizationKey.$dossierId/protocol_subscriptions.new.$autoProtocolId'
import { Route as OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRouteImport } from './routes/$organizationKey.$dossierId/questionnaires.show.$questionnaireId'
import { Route as OrganizationKeyDossierIdReportsNewIndexRouteImport } from './routes/$organizationKey.$dossierId/reports.new.index'
import { Route as OrganizationKeyDossierIdReportsShowReportIdRouteImport } from './routes/$organizationKey.$dossierId/reports.show.$reportId'
import { Route as OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRouteImport } from './routes/$organizationKey.$dossierId/dossier/respondents.$respondentId.index'
import { Route as OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRouteImport } from './routes/$organizationKey.$dossierId/dossier/respondents.$respondentId.manage-login'
import { Route as OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRouteImport } from './routes/$organizationKey.$dossierId/reports.new.$reportTemplateId.index'
import { Route as OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRouteImport } from './routes/$organizationKey.$dossierId/reports.new.$reportTemplateId.preview'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const NotLoggedInRoute = NotLoggedInRouteImport.update({
  id: '/not-logged-in',
  path: '/not-logged-in',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationKeyDossierIdRoute =
  OrganizationKeyDossierIdRouteImport.update({
    id: '/$organizationKey/$dossierId',
    path: '/$organizationKey/$dossierId',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationKeyDossierIdIndexRoute =
  OrganizationKeyDossierIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdAnnouncementsRoute =
  OrganizationKeyDossierIdAnnouncementsRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdLab_test_resultsRoute =
  OrganizationKeyDossierIdLab_test_resultsRouteImport.update({
    id: '/lab_test_results',
    path: '/lab_test_results',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdMeasureRoute =
  OrganizationKeyDossierIdMeasureRouteImport.update({
    id: '/measure',
    path: '/measure',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdPendingRoute =
  OrganizationKeyDossierIdPendingRouteImport.update({
    id: '/pending',
    path: '/pending',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdPreferencesRoute =
  OrganizationKeyDossierIdPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRoute =
  OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRouteImport.update(
    {
      id: '/self_initiable_measured_questionnaires',
      path: '/self_initiable_measured_questionnaires',
      getParentRoute: () => OrganizationKeyDossierIdRoute,
    } as any,
  )
const OrganizationKeyDossierIdDesignIndexRoute =
  OrganizationKeyDossierIdDesignIndexRouteImport.update({
    id: '/design/',
    path: '/design/',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdDesignColorsRoute =
  OrganizationKeyDossierIdDesignColorsRouteImport.update({
    id: '/design/colors',
    path: '/design/colors',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdDesignComponentsRoute =
  OrganizationKeyDossierIdDesignComponentsRouteImport.update({
    id: '/design/components',
    path: '/design/components',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdDesignFormsRoute =
  OrganizationKeyDossierIdDesignFormsRouteImport.update({
    id: '/design/forms',
    path: '/design/forms',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdDossierIndexRoute =
  OrganizationKeyDossierIdDossierIndexRouteImport.update({
    id: '/dossier/',
    path: '/dossier/',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdDossierDemographicsRoute =
  OrganizationKeyDossierIdDossierDemographicsRouteImport.update({
    id: '/dossier/demographics',
    path: '/dossier/demographics',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdDossierMetadataRoute =
  OrganizationKeyDossierIdDossierMetadataRouteImport.update({
    id: '/dossier/metadata',
    path: '/dossier/metadata',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdNotificationsNewRoute =
  OrganizationKeyDossierIdNotificationsNewRouteImport.update({
    id: '/notifications/new',
    path: '/notifications/new',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute =
  OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteImport.update({
    id: '/outcome/$questionnaireId',
    path: '/outcome/$questionnaireId',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdProtocol_subscriptionsIndexRoute =
  OrganizationKeyDossierIdProtocol_subscriptionsIndexRouteImport.update({
    id: '/protocol_subscriptions/',
    path: '/protocol_subscriptions/',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdProtocol_subscriptionsStoppedRoute =
  OrganizationKeyDossierIdProtocol_subscriptionsStoppedRouteImport.update({
    id: '/protocol_subscriptions/stopped',
    path: '/protocol_subscriptions/stopped',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdQuestionnairesIndexRoute =
  OrganizationKeyDossierIdQuestionnairesIndexRouteImport.update({
    id: '/questionnaires/',
    path: '/questionnaires/',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRoute =
  OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRouteImport.update(
    {
      id: '/fill_out_wizard/$measurementId/create_direct',
      path: '/fill_out_wizard/$measurementId/create_direct',
      getParentRoute: () => OrganizationKeyDossierIdRoute,
    } as any,
  )
const OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRoute =
  OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRouteImport.update(
    {
      id: '/fill_out_wizard/$measurementId/create_fill_out_request',
      path: '/fill_out_wizard/$measurementId/create_fill_out_request',
      getParentRoute: () => OrganizationKeyDossierIdRoute,
    } as any,
  )
const OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRoute =
  OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRouteImport.update(
    {
      id: '/fill_out_wizard/$measurementId/create_fill_out_session',
      path: '/fill_out_wizard/$measurementId/create_fill_out_session',
      getParentRoute: () => OrganizationKeyDossierIdRoute,
    } as any,
  )
const OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRoute =
  OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRouteImport.update(
    {
      id: '/fill_out_wizard/$measurementId/create_non_response',
      path: '/fill_out_wizard/$measurementId/create_non_response',
      getParentRoute: () => OrganizationKeyDossierIdRoute,
    } as any,
  )
const OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRoute =
  OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRouteImport.update(
    {
      id: '/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires',
      path: '/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires',
      getParentRoute: () => OrganizationKeyDossierIdRoute,
    } as any,
  )
const OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRoute =
  OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRouteImport.update(
    {
      id: '/fill_out_wizard_new/$measurementId/choose',
      path: '/fill_out_wizard_new/$measurementId/choose',
      getParentRoute: () => OrganizationKeyDossierIdRoute,
    } as any,
  )
const OrganizationKeyDossierIdNon_responsesShowNonResponseIdRoute =
  OrganizationKeyDossierIdNon_responsesShowNonResponseIdRouteImport.update({
    id: '/non_responses/show/$nonResponseId',
    path: '/non_responses/show/$nonResponseId',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdNotificationsShowNotificationIdRoute =
  OrganizationKeyDossierIdNotificationsShowNotificationIdRouteImport.update({
    id: '/notifications/show/$notificationId',
    path: '/notifications/show/$notificationId',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRoute =
  OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRouteImport.update({
    id: '/answers',
    path: '/answers',
    getParentRoute: () => OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute,
  } as any)
const OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRoute =
  OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRouteImport.update({
    id: '/charts',
    path: '/charts',
    getParentRoute: () => OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute,
  } as any)
const OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRoute =
  OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRouteImport.update({
    id: '/help',
    path: '/help',
    getParentRoute: () => OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute,
  } as any)
const OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRoute =
  OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRouteImport.update({
    id: '/scores',
    path: '/scores',
    getParentRoute: () => OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute,
  } as any)
const OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRoute =
  OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRouteImport.update(
    {
      id: '/protocol_subscriptions/new/$autoProtocolId',
      path: '/protocol_subscriptions/new/$autoProtocolId',
      getParentRoute: () => OrganizationKeyDossierIdRoute,
    } as any,
  )
const OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRoute =
  OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRouteImport.update({
    id: '/questionnaires/show/$questionnaireId',
    path: '/questionnaires/show/$questionnaireId',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdReportsNewIndexRoute =
  OrganizationKeyDossierIdReportsNewIndexRouteImport.update({
    id: '/reports/new/',
    path: '/reports/new/',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdReportsShowReportIdRoute =
  OrganizationKeyDossierIdReportsShowReportIdRouteImport.update({
    id: '/reports/show/$reportId',
    path: '/reports/show/$reportId',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRoute =
  OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRouteImport.update(
    {
      id: '/dossier/respondents/$respondentId/',
      path: '/dossier/respondents/$respondentId/',
      getParentRoute: () => OrganizationKeyDossierIdRoute,
    } as any,
  )
const OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRoute =
  OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRouteImport.update(
    {
      id: '/dossier/respondents/$respondentId/manage-login',
      path: '/dossier/respondents/$respondentId/manage-login',
      getParentRoute: () => OrganizationKeyDossierIdRoute,
    } as any,
  )
const OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRoute =
  OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRouteImport.update({
    id: '/reports/new/$reportTemplateId/',
    path: '/reports/new/$reportTemplateId/',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)
const OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRoute =
  OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRouteImport.update({
    id: '/reports/new/$reportTemplateId/preview',
    path: '/reports/new/$reportTemplateId/preview',
    getParentRoute: () => OrganizationKeyDossierIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/not-logged-in': typeof NotLoggedInRoute
  '/$organizationKey/$dossierId': typeof OrganizationKeyDossierIdRouteWithChildren
  '/$organizationKey/$dossierId/announcements': typeof OrganizationKeyDossierIdAnnouncementsRoute
  '/$organizationKey/$dossierId/lab_test_results': typeof OrganizationKeyDossierIdLab_test_resultsRoute
  '/$organizationKey/$dossierId/measure': typeof OrganizationKeyDossierIdMeasureRoute
  '/$organizationKey/$dossierId/pending': typeof OrganizationKeyDossierIdPendingRoute
  '/$organizationKey/$dossierId/preferences': typeof OrganizationKeyDossierIdPreferencesRoute
  '/$organizationKey/$dossierId/self_initiable_measured_questionnaires': typeof OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRoute
  '/$organizationKey/$dossierId/': typeof OrganizationKeyDossierIdIndexRoute
  '/$organizationKey/$dossierId/design/colors': typeof OrganizationKeyDossierIdDesignColorsRoute
  '/$organizationKey/$dossierId/design/components': typeof OrganizationKeyDossierIdDesignComponentsRoute
  '/$organizationKey/$dossierId/design/forms': typeof OrganizationKeyDossierIdDesignFormsRoute
  '/$organizationKey/$dossierId/dossier/demographics': typeof OrganizationKeyDossierIdDossierDemographicsRoute
  '/$organizationKey/$dossierId/dossier/metadata': typeof OrganizationKeyDossierIdDossierMetadataRoute
  '/$organizationKey/$dossierId/notifications/new': typeof OrganizationKeyDossierIdNotificationsNewRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteWithChildren
  '/$organizationKey/$dossierId/protocol_subscriptions/stopped': typeof OrganizationKeyDossierIdProtocol_subscriptionsStoppedRoute
  '/$organizationKey/$dossierId/design/': typeof OrganizationKeyDossierIdDesignIndexRoute
  '/$organizationKey/$dossierId/dossier/': typeof OrganizationKeyDossierIdDossierIndexRoute
  '/$organizationKey/$dossierId/protocol_subscriptions/': typeof OrganizationKeyDossierIdProtocol_subscriptionsIndexRoute
  '/$organizationKey/$dossierId/questionnaires/': typeof OrganizationKeyDossierIdQuestionnairesIndexRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_direct': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_request': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_session': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_non_response': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRoute
  '/$organizationKey/$dossierId/fill_out_wizard_new/$measurementId/choose': typeof OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRoute
  '/$organizationKey/$dossierId/non_responses/show/$nonResponseId': typeof OrganizationKeyDossierIdNon_responsesShowNonResponseIdRoute
  '/$organizationKey/$dossierId/notifications/show/$notificationId': typeof OrganizationKeyDossierIdNotificationsShowNotificationIdRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/answers': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/charts': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/help': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/scores': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRoute
  '/$organizationKey/$dossierId/protocol_subscriptions/new/$autoProtocolId': typeof OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRoute
  '/$organizationKey/$dossierId/questionnaires/show/$questionnaireId': typeof OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRoute
  '/$organizationKey/$dossierId/reports/show/$reportId': typeof OrganizationKeyDossierIdReportsShowReportIdRoute
  '/$organizationKey/$dossierId/reports/new/': typeof OrganizationKeyDossierIdReportsNewIndexRoute
  '/$organizationKey/$dossierId/dossier/respondents/$respondentId/manage-login': typeof OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRoute
  '/$organizationKey/$dossierId/reports/new/$reportTemplateId/preview': typeof OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRoute
  '/$organizationKey/$dossierId/dossier/respondents/$respondentId/': typeof OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRoute
  '/$organizationKey/$dossierId/reports/new/$reportTemplateId/': typeof OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/not-logged-in': typeof NotLoggedInRoute
  '/$organizationKey/$dossierId/announcements': typeof OrganizationKeyDossierIdAnnouncementsRoute
  '/$organizationKey/$dossierId/lab_test_results': typeof OrganizationKeyDossierIdLab_test_resultsRoute
  '/$organizationKey/$dossierId/measure': typeof OrganizationKeyDossierIdMeasureRoute
  '/$organizationKey/$dossierId/pending': typeof OrganizationKeyDossierIdPendingRoute
  '/$organizationKey/$dossierId/preferences': typeof OrganizationKeyDossierIdPreferencesRoute
  '/$organizationKey/$dossierId/self_initiable_measured_questionnaires': typeof OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRoute
  '/$organizationKey/$dossierId': typeof OrganizationKeyDossierIdIndexRoute
  '/$organizationKey/$dossierId/design/colors': typeof OrganizationKeyDossierIdDesignColorsRoute
  '/$organizationKey/$dossierId/design/components': typeof OrganizationKeyDossierIdDesignComponentsRoute
  '/$organizationKey/$dossierId/design/forms': typeof OrganizationKeyDossierIdDesignFormsRoute
  '/$organizationKey/$dossierId/dossier/demographics': typeof OrganizationKeyDossierIdDossierDemographicsRoute
  '/$organizationKey/$dossierId/dossier/metadata': typeof OrganizationKeyDossierIdDossierMetadataRoute
  '/$organizationKey/$dossierId/notifications/new': typeof OrganizationKeyDossierIdNotificationsNewRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteWithChildren
  '/$organizationKey/$dossierId/protocol_subscriptions/stopped': typeof OrganizationKeyDossierIdProtocol_subscriptionsStoppedRoute
  '/$organizationKey/$dossierId/design': typeof OrganizationKeyDossierIdDesignIndexRoute
  '/$organizationKey/$dossierId/dossier': typeof OrganizationKeyDossierIdDossierIndexRoute
  '/$organizationKey/$dossierId/protocol_subscriptions': typeof OrganizationKeyDossierIdProtocol_subscriptionsIndexRoute
  '/$organizationKey/$dossierId/questionnaires': typeof OrganizationKeyDossierIdQuestionnairesIndexRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_direct': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_request': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_session': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_non_response': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRoute
  '/$organizationKey/$dossierId/fill_out_wizard_new/$measurementId/choose': typeof OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRoute
  '/$organizationKey/$dossierId/non_responses/show/$nonResponseId': typeof OrganizationKeyDossierIdNon_responsesShowNonResponseIdRoute
  '/$organizationKey/$dossierId/notifications/show/$notificationId': typeof OrganizationKeyDossierIdNotificationsShowNotificationIdRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/answers': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/charts': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/help': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/scores': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRoute
  '/$organizationKey/$dossierId/protocol_subscriptions/new/$autoProtocolId': typeof OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRoute
  '/$organizationKey/$dossierId/questionnaires/show/$questionnaireId': typeof OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRoute
  '/$organizationKey/$dossierId/reports/show/$reportId': typeof OrganizationKeyDossierIdReportsShowReportIdRoute
  '/$organizationKey/$dossierId/reports/new': typeof OrganizationKeyDossierIdReportsNewIndexRoute
  '/$organizationKey/$dossierId/dossier/respondents/$respondentId/manage-login': typeof OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRoute
  '/$organizationKey/$dossierId/reports/new/$reportTemplateId/preview': typeof OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRoute
  '/$organizationKey/$dossierId/dossier/respondents/$respondentId': typeof OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRoute
  '/$organizationKey/$dossierId/reports/new/$reportTemplateId': typeof OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/not-logged-in': typeof NotLoggedInRoute
  '/$organizationKey/$dossierId': typeof OrganizationKeyDossierIdRouteWithChildren
  '/$organizationKey/$dossierId/announcements': typeof OrganizationKeyDossierIdAnnouncementsRoute
  '/$organizationKey/$dossierId/lab_test_results': typeof OrganizationKeyDossierIdLab_test_resultsRoute
  '/$organizationKey/$dossierId/measure': typeof OrganizationKeyDossierIdMeasureRoute
  '/$organizationKey/$dossierId/pending': typeof OrganizationKeyDossierIdPendingRoute
  '/$organizationKey/$dossierId/preferences': typeof OrganizationKeyDossierIdPreferencesRoute
  '/$organizationKey/$dossierId/self_initiable_measured_questionnaires': typeof OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRoute
  '/$organizationKey/$dossierId/': typeof OrganizationKeyDossierIdIndexRoute
  '/$organizationKey/$dossierId/design/colors': typeof OrganizationKeyDossierIdDesignColorsRoute
  '/$organizationKey/$dossierId/design/components': typeof OrganizationKeyDossierIdDesignComponentsRoute
  '/$organizationKey/$dossierId/design/forms': typeof OrganizationKeyDossierIdDesignFormsRoute
  '/$organizationKey/$dossierId/dossier/demographics': typeof OrganizationKeyDossierIdDossierDemographicsRoute
  '/$organizationKey/$dossierId/dossier/metadata': typeof OrganizationKeyDossierIdDossierMetadataRoute
  '/$organizationKey/$dossierId/notifications/new': typeof OrganizationKeyDossierIdNotificationsNewRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteWithChildren
  '/$organizationKey/$dossierId/protocol_subscriptions/stopped': typeof OrganizationKeyDossierIdProtocol_subscriptionsStoppedRoute
  '/$organizationKey/$dossierId/design/': typeof OrganizationKeyDossierIdDesignIndexRoute
  '/$organizationKey/$dossierId/dossier/': typeof OrganizationKeyDossierIdDossierIndexRoute
  '/$organizationKey/$dossierId/protocol_subscriptions/': typeof OrganizationKeyDossierIdProtocol_subscriptionsIndexRoute
  '/$organizationKey/$dossierId/questionnaires/': typeof OrganizationKeyDossierIdQuestionnairesIndexRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_direct': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_request': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_session': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_non_response': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRoute
  '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires': typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRoute
  '/$organizationKey/$dossierId/fill_out_wizard_new/$measurementId/choose': typeof OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRoute
  '/$organizationKey/$dossierId/non_responses/show/$nonResponseId': typeof OrganizationKeyDossierIdNon_responsesShowNonResponseIdRoute
  '/$organizationKey/$dossierId/notifications/show/$notificationId': typeof OrganizationKeyDossierIdNotificationsShowNotificationIdRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/answers': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/charts': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/help': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRoute
  '/$organizationKey/$dossierId/outcome/$questionnaireId/scores': typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRoute
  '/$organizationKey/$dossierId/protocol_subscriptions/new/$autoProtocolId': typeof OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRoute
  '/$organizationKey/$dossierId/questionnaires/show/$questionnaireId': typeof OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRoute
  '/$organizationKey/$dossierId/reports/show/$reportId': typeof OrganizationKeyDossierIdReportsShowReportIdRoute
  '/$organizationKey/$dossierId/reports/new/': typeof OrganizationKeyDossierIdReportsNewIndexRoute
  '/$organizationKey/$dossierId/dossier/respondents/$respondentId/manage-login': typeof OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRoute
  '/$organizationKey/$dossierId/reports/new/$reportTemplateId/preview': typeof OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRoute
  '/$organizationKey/$dossierId/dossier/respondents/$respondentId/': typeof OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRoute
  '/$organizationKey/$dossierId/reports/new/$reportTemplateId/': typeof OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/not-logged-in'
    | '/$organizationKey/$dossierId'
    | '/$organizationKey/$dossierId/announcements'
    | '/$organizationKey/$dossierId/lab_test_results'
    | '/$organizationKey/$dossierId/measure'
    | '/$organizationKey/$dossierId/pending'
    | '/$organizationKey/$dossierId/preferences'
    | '/$organizationKey/$dossierId/self_initiable_measured_questionnaires'
    | '/$organizationKey/$dossierId/'
    | '/$organizationKey/$dossierId/design/colors'
    | '/$organizationKey/$dossierId/design/components'
    | '/$organizationKey/$dossierId/design/forms'
    | '/$organizationKey/$dossierId/dossier/demographics'
    | '/$organizationKey/$dossierId/dossier/metadata'
    | '/$organizationKey/$dossierId/notifications/new'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId'
    | '/$organizationKey/$dossierId/protocol_subscriptions/stopped'
    | '/$organizationKey/$dossierId/design/'
    | '/$organizationKey/$dossierId/dossier/'
    | '/$organizationKey/$dossierId/protocol_subscriptions/'
    | '/$organizationKey/$dossierId/questionnaires/'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_direct'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_request'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_session'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_non_response'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires'
    | '/$organizationKey/$dossierId/fill_out_wizard_new/$measurementId/choose'
    | '/$organizationKey/$dossierId/non_responses/show/$nonResponseId'
    | '/$organizationKey/$dossierId/notifications/show/$notificationId'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/answers'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/charts'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/help'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/scores'
    | '/$organizationKey/$dossierId/protocol_subscriptions/new/$autoProtocolId'
    | '/$organizationKey/$dossierId/questionnaires/show/$questionnaireId'
    | '/$organizationKey/$dossierId/reports/show/$reportId'
    | '/$organizationKey/$dossierId/reports/new/'
    | '/$organizationKey/$dossierId/dossier/respondents/$respondentId/manage-login'
    | '/$organizationKey/$dossierId/reports/new/$reportTemplateId/preview'
    | '/$organizationKey/$dossierId/dossier/respondents/$respondentId/'
    | '/$organizationKey/$dossierId/reports/new/$reportTemplateId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/not-logged-in'
    | '/$organizationKey/$dossierId/announcements'
    | '/$organizationKey/$dossierId/lab_test_results'
    | '/$organizationKey/$dossierId/measure'
    | '/$organizationKey/$dossierId/pending'
    | '/$organizationKey/$dossierId/preferences'
    | '/$organizationKey/$dossierId/self_initiable_measured_questionnaires'
    | '/$organizationKey/$dossierId'
    | '/$organizationKey/$dossierId/design/colors'
    | '/$organizationKey/$dossierId/design/components'
    | '/$organizationKey/$dossierId/design/forms'
    | '/$organizationKey/$dossierId/dossier/demographics'
    | '/$organizationKey/$dossierId/dossier/metadata'
    | '/$organizationKey/$dossierId/notifications/new'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId'
    | '/$organizationKey/$dossierId/protocol_subscriptions/stopped'
    | '/$organizationKey/$dossierId/design'
    | '/$organizationKey/$dossierId/dossier'
    | '/$organizationKey/$dossierId/protocol_subscriptions'
    | '/$organizationKey/$dossierId/questionnaires'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_direct'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_request'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_session'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_non_response'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires'
    | '/$organizationKey/$dossierId/fill_out_wizard_new/$measurementId/choose'
    | '/$organizationKey/$dossierId/non_responses/show/$nonResponseId'
    | '/$organizationKey/$dossierId/notifications/show/$notificationId'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/answers'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/charts'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/help'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/scores'
    | '/$organizationKey/$dossierId/protocol_subscriptions/new/$autoProtocolId'
    | '/$organizationKey/$dossierId/questionnaires/show/$questionnaireId'
    | '/$organizationKey/$dossierId/reports/show/$reportId'
    | '/$organizationKey/$dossierId/reports/new'
    | '/$organizationKey/$dossierId/dossier/respondents/$respondentId/manage-login'
    | '/$organizationKey/$dossierId/reports/new/$reportTemplateId/preview'
    | '/$organizationKey/$dossierId/dossier/respondents/$respondentId'
    | '/$organizationKey/$dossierId/reports/new/$reportTemplateId'
  id:
    | '__root__'
    | '/'
    | '/not-logged-in'
    | '/$organizationKey/$dossierId'
    | '/$organizationKey/$dossierId/announcements'
    | '/$organizationKey/$dossierId/lab_test_results'
    | '/$organizationKey/$dossierId/measure'
    | '/$organizationKey/$dossierId/pending'
    | '/$organizationKey/$dossierId/preferences'
    | '/$organizationKey/$dossierId/self_initiable_measured_questionnaires'
    | '/$organizationKey/$dossierId/'
    | '/$organizationKey/$dossierId/design/colors'
    | '/$organizationKey/$dossierId/design/components'
    | '/$organizationKey/$dossierId/design/forms'
    | '/$organizationKey/$dossierId/dossier/demographics'
    | '/$organizationKey/$dossierId/dossier/metadata'
    | '/$organizationKey/$dossierId/notifications/new'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId'
    | '/$organizationKey/$dossierId/protocol_subscriptions/stopped'
    | '/$organizationKey/$dossierId/design/'
    | '/$organizationKey/$dossierId/dossier/'
    | '/$organizationKey/$dossierId/protocol_subscriptions/'
    | '/$organizationKey/$dossierId/questionnaires/'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_direct'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_request'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_session'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_non_response'
    | '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires'
    | '/$organizationKey/$dossierId/fill_out_wizard_new/$measurementId/choose'
    | '/$organizationKey/$dossierId/non_responses/show/$nonResponseId'
    | '/$organizationKey/$dossierId/notifications/show/$notificationId'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/answers'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/charts'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/help'
    | '/$organizationKey/$dossierId/outcome/$questionnaireId/scores'
    | '/$organizationKey/$dossierId/protocol_subscriptions/new/$autoProtocolId'
    | '/$organizationKey/$dossierId/questionnaires/show/$questionnaireId'
    | '/$organizationKey/$dossierId/reports/show/$reportId'
    | '/$organizationKey/$dossierId/reports/new/'
    | '/$organizationKey/$dossierId/dossier/respondents/$respondentId/manage-login'
    | '/$organizationKey/$dossierId/reports/new/$reportTemplateId/preview'
    | '/$organizationKey/$dossierId/dossier/respondents/$respondentId/'
    | '/$organizationKey/$dossierId/reports/new/$reportTemplateId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  NotLoggedInRoute: typeof NotLoggedInRoute
  OrganizationKeyDossierIdRoute: typeof OrganizationKeyDossierIdRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/not-logged-in': {
      id: '/not-logged-in'
      path: '/not-logged-in'
      fullPath: '/not-logged-in'
      preLoaderRoute: typeof NotLoggedInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationKey/$dossierId': {
      id: '/$organizationKey/$dossierId'
      path: '/$organizationKey/$dossierId'
      fullPath: '/$organizationKey/$dossierId'
      preLoaderRoute: typeof OrganizationKeyDossierIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationKey/$dossierId/': {
      id: '/$organizationKey/$dossierId/'
      path: '/'
      fullPath: '/$organizationKey/$dossierId/'
      preLoaderRoute: typeof OrganizationKeyDossierIdIndexRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/announcements': {
      id: '/$organizationKey/$dossierId/announcements'
      path: '/announcements'
      fullPath: '/$organizationKey/$dossierId/announcements'
      preLoaderRoute: typeof OrganizationKeyDossierIdAnnouncementsRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/lab_test_results': {
      id: '/$organizationKey/$dossierId/lab_test_results'
      path: '/lab_test_results'
      fullPath: '/$organizationKey/$dossierId/lab_test_results'
      preLoaderRoute: typeof OrganizationKeyDossierIdLab_test_resultsRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/measure': {
      id: '/$organizationKey/$dossierId/measure'
      path: '/measure'
      fullPath: '/$organizationKey/$dossierId/measure'
      preLoaderRoute: typeof OrganizationKeyDossierIdMeasureRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/pending': {
      id: '/$organizationKey/$dossierId/pending'
      path: '/pending'
      fullPath: '/$organizationKey/$dossierId/pending'
      preLoaderRoute: typeof OrganizationKeyDossierIdPendingRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/preferences': {
      id: '/$organizationKey/$dossierId/preferences'
      path: '/preferences'
      fullPath: '/$organizationKey/$dossierId/preferences'
      preLoaderRoute: typeof OrganizationKeyDossierIdPreferencesRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/self_initiable_measured_questionnaires': {
      id: '/$organizationKey/$dossierId/self_initiable_measured_questionnaires'
      path: '/self_initiable_measured_questionnaires'
      fullPath: '/$organizationKey/$dossierId/self_initiable_measured_questionnaires'
      preLoaderRoute: typeof OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/design/': {
      id: '/$organizationKey/$dossierId/design/'
      path: '/design'
      fullPath: '/$organizationKey/$dossierId/design/'
      preLoaderRoute: typeof OrganizationKeyDossierIdDesignIndexRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/design/colors': {
      id: '/$organizationKey/$dossierId/design/colors'
      path: '/design/colors'
      fullPath: '/$organizationKey/$dossierId/design/colors'
      preLoaderRoute: typeof OrganizationKeyDossierIdDesignColorsRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/design/components': {
      id: '/$organizationKey/$dossierId/design/components'
      path: '/design/components'
      fullPath: '/$organizationKey/$dossierId/design/components'
      preLoaderRoute: typeof OrganizationKeyDossierIdDesignComponentsRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/design/forms': {
      id: '/$organizationKey/$dossierId/design/forms'
      path: '/design/forms'
      fullPath: '/$organizationKey/$dossierId/design/forms'
      preLoaderRoute: typeof OrganizationKeyDossierIdDesignFormsRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/dossier/': {
      id: '/$organizationKey/$dossierId/dossier/'
      path: '/dossier'
      fullPath: '/$organizationKey/$dossierId/dossier/'
      preLoaderRoute: typeof OrganizationKeyDossierIdDossierIndexRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/dossier/demographics': {
      id: '/$organizationKey/$dossierId/dossier/demographics'
      path: '/dossier/demographics'
      fullPath: '/$organizationKey/$dossierId/dossier/demographics'
      preLoaderRoute: typeof OrganizationKeyDossierIdDossierDemographicsRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/dossier/metadata': {
      id: '/$organizationKey/$dossierId/dossier/metadata'
      path: '/dossier/metadata'
      fullPath: '/$organizationKey/$dossierId/dossier/metadata'
      preLoaderRoute: typeof OrganizationKeyDossierIdDossierMetadataRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/notifications/new': {
      id: '/$organizationKey/$dossierId/notifications/new'
      path: '/notifications/new'
      fullPath: '/$organizationKey/$dossierId/notifications/new'
      preLoaderRoute: typeof OrganizationKeyDossierIdNotificationsNewRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/outcome/$questionnaireId': {
      id: '/$organizationKey/$dossierId/outcome/$questionnaireId'
      path: '/outcome/$questionnaireId'
      fullPath: '/$organizationKey/$dossierId/outcome/$questionnaireId'
      preLoaderRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/protocol_subscriptions/': {
      id: '/$organizationKey/$dossierId/protocol_subscriptions/'
      path: '/protocol_subscriptions'
      fullPath: '/$organizationKey/$dossierId/protocol_subscriptions/'
      preLoaderRoute: typeof OrganizationKeyDossierIdProtocol_subscriptionsIndexRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/protocol_subscriptions/stopped': {
      id: '/$organizationKey/$dossierId/protocol_subscriptions/stopped'
      path: '/protocol_subscriptions/stopped'
      fullPath: '/$organizationKey/$dossierId/protocol_subscriptions/stopped'
      preLoaderRoute: typeof OrganizationKeyDossierIdProtocol_subscriptionsStoppedRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/questionnaires/': {
      id: '/$organizationKey/$dossierId/questionnaires/'
      path: '/questionnaires'
      fullPath: '/$organizationKey/$dossierId/questionnaires/'
      preLoaderRoute: typeof OrganizationKeyDossierIdQuestionnairesIndexRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_direct': {
      id: '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_direct'
      path: '/fill_out_wizard/$measurementId/create_direct'
      fullPath: '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_direct'
      preLoaderRoute: typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_request': {
      id: '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_request'
      path: '/fill_out_wizard/$measurementId/create_fill_out_request'
      fullPath: '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_request'
      preLoaderRoute: typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_session': {
      id: '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_session'
      path: '/fill_out_wizard/$measurementId/create_fill_out_session'
      fullPath: '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_fill_out_session'
      preLoaderRoute: typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_non_response': {
      id: '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_non_response'
      path: '/fill_out_wizard/$measurementId/create_non_response'
      fullPath: '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_non_response'
      preLoaderRoute: typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires': {
      id: '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires'
      path: '/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires'
      fullPath: '/$organizationKey/$dossierId/fill_out_wizard/$measurementId/create_self_initiable_measured_questionnaires'
      preLoaderRoute: typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/fill_out_wizard_new/$measurementId/choose': {
      id: '/$organizationKey/$dossierId/fill_out_wizard_new/$measurementId/choose'
      path: '/fill_out_wizard_new/$measurementId/choose'
      fullPath: '/$organizationKey/$dossierId/fill_out_wizard_new/$measurementId/choose'
      preLoaderRoute: typeof OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/non_responses/show/$nonResponseId': {
      id: '/$organizationKey/$dossierId/non_responses/show/$nonResponseId'
      path: '/non_responses/show/$nonResponseId'
      fullPath: '/$organizationKey/$dossierId/non_responses/show/$nonResponseId'
      preLoaderRoute: typeof OrganizationKeyDossierIdNon_responsesShowNonResponseIdRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/notifications/show/$notificationId': {
      id: '/$organizationKey/$dossierId/notifications/show/$notificationId'
      path: '/notifications/show/$notificationId'
      fullPath: '/$organizationKey/$dossierId/notifications/show/$notificationId'
      preLoaderRoute: typeof OrganizationKeyDossierIdNotificationsShowNotificationIdRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/outcome/$questionnaireId/answers': {
      id: '/$organizationKey/$dossierId/outcome/$questionnaireId/answers'
      path: '/answers'
      fullPath: '/$organizationKey/$dossierId/outcome/$questionnaireId/answers'
      preLoaderRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRouteImport
      parentRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute
    }
    '/$organizationKey/$dossierId/outcome/$questionnaireId/charts': {
      id: '/$organizationKey/$dossierId/outcome/$questionnaireId/charts'
      path: '/charts'
      fullPath: '/$organizationKey/$dossierId/outcome/$questionnaireId/charts'
      preLoaderRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRouteImport
      parentRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute
    }
    '/$organizationKey/$dossierId/outcome/$questionnaireId/help': {
      id: '/$organizationKey/$dossierId/outcome/$questionnaireId/help'
      path: '/help'
      fullPath: '/$organizationKey/$dossierId/outcome/$questionnaireId/help'
      preLoaderRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRouteImport
      parentRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute
    }
    '/$organizationKey/$dossierId/outcome/$questionnaireId/scores': {
      id: '/$organizationKey/$dossierId/outcome/$questionnaireId/scores'
      path: '/scores'
      fullPath: '/$organizationKey/$dossierId/outcome/$questionnaireId/scores'
      preLoaderRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRouteImport
      parentRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute
    }
    '/$organizationKey/$dossierId/protocol_subscriptions/new/$autoProtocolId': {
      id: '/$organizationKey/$dossierId/protocol_subscriptions/new/$autoProtocolId'
      path: '/protocol_subscriptions/new/$autoProtocolId'
      fullPath: '/$organizationKey/$dossierId/protocol_subscriptions/new/$autoProtocolId'
      preLoaderRoute: typeof OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/questionnaires/show/$questionnaireId': {
      id: '/$organizationKey/$dossierId/questionnaires/show/$questionnaireId'
      path: '/questionnaires/show/$questionnaireId'
      fullPath: '/$organizationKey/$dossierId/questionnaires/show/$questionnaireId'
      preLoaderRoute: typeof OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/reports/new/': {
      id: '/$organizationKey/$dossierId/reports/new/'
      path: '/reports/new'
      fullPath: '/$organizationKey/$dossierId/reports/new/'
      preLoaderRoute: typeof OrganizationKeyDossierIdReportsNewIndexRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/reports/show/$reportId': {
      id: '/$organizationKey/$dossierId/reports/show/$reportId'
      path: '/reports/show/$reportId'
      fullPath: '/$organizationKey/$dossierId/reports/show/$reportId'
      preLoaderRoute: typeof OrganizationKeyDossierIdReportsShowReportIdRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/dossier/respondents/$respondentId/': {
      id: '/$organizationKey/$dossierId/dossier/respondents/$respondentId/'
      path: '/dossier/respondents/$respondentId'
      fullPath: '/$organizationKey/$dossierId/dossier/respondents/$respondentId/'
      preLoaderRoute: typeof OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/dossier/respondents/$respondentId/manage-login': {
      id: '/$organizationKey/$dossierId/dossier/respondents/$respondentId/manage-login'
      path: '/dossier/respondents/$respondentId/manage-login'
      fullPath: '/$organizationKey/$dossierId/dossier/respondents/$respondentId/manage-login'
      preLoaderRoute: typeof OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/reports/new/$reportTemplateId/': {
      id: '/$organizationKey/$dossierId/reports/new/$reportTemplateId/'
      path: '/reports/new/$reportTemplateId'
      fullPath: '/$organizationKey/$dossierId/reports/new/$reportTemplateId/'
      preLoaderRoute: typeof OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
    '/$organizationKey/$dossierId/reports/new/$reportTemplateId/preview': {
      id: '/$organizationKey/$dossierId/reports/new/$reportTemplateId/preview'
      path: '/reports/new/$reportTemplateId/preview'
      fullPath: '/$organizationKey/$dossierId/reports/new/$reportTemplateId/preview'
      preLoaderRoute: typeof OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRouteImport
      parentRoute: typeof OrganizationKeyDossierIdRoute
    }
  }
}

interface OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteChildren {
  OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRoute
  OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRoute
  OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRoute
  OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRoute
}

const OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteChildren: OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteChildren =
  {
    OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRoute:
      OrganizationKeyDossierIdOutcomeQuestionnaireIdAnswersRoute,
    OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRoute:
      OrganizationKeyDossierIdOutcomeQuestionnaireIdChartsRoute,
    OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRoute:
      OrganizationKeyDossierIdOutcomeQuestionnaireIdHelpRoute,
    OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRoute:
      OrganizationKeyDossierIdOutcomeQuestionnaireIdScoresRoute,
  }

const OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteWithChildren =
  OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute._addFileChildren(
    OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteChildren,
  )

interface OrganizationKeyDossierIdRouteChildren {
  OrganizationKeyDossierIdAnnouncementsRoute: typeof OrganizationKeyDossierIdAnnouncementsRoute
  OrganizationKeyDossierIdLab_test_resultsRoute: typeof OrganizationKeyDossierIdLab_test_resultsRoute
  OrganizationKeyDossierIdMeasureRoute: typeof OrganizationKeyDossierIdMeasureRoute
  OrganizationKeyDossierIdPendingRoute: typeof OrganizationKeyDossierIdPendingRoute
  OrganizationKeyDossierIdPreferencesRoute: typeof OrganizationKeyDossierIdPreferencesRoute
  OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRoute: typeof OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRoute
  OrganizationKeyDossierIdIndexRoute: typeof OrganizationKeyDossierIdIndexRoute
  OrganizationKeyDossierIdDesignColorsRoute: typeof OrganizationKeyDossierIdDesignColorsRoute
  OrganizationKeyDossierIdDesignComponentsRoute: typeof OrganizationKeyDossierIdDesignComponentsRoute
  OrganizationKeyDossierIdDesignFormsRoute: typeof OrganizationKeyDossierIdDesignFormsRoute
  OrganizationKeyDossierIdDossierDemographicsRoute: typeof OrganizationKeyDossierIdDossierDemographicsRoute
  OrganizationKeyDossierIdDossierMetadataRoute: typeof OrganizationKeyDossierIdDossierMetadataRoute
  OrganizationKeyDossierIdNotificationsNewRoute: typeof OrganizationKeyDossierIdNotificationsNewRoute
  OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute: typeof OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteWithChildren
  OrganizationKeyDossierIdProtocol_subscriptionsStoppedRoute: typeof OrganizationKeyDossierIdProtocol_subscriptionsStoppedRoute
  OrganizationKeyDossierIdDesignIndexRoute: typeof OrganizationKeyDossierIdDesignIndexRoute
  OrganizationKeyDossierIdDossierIndexRoute: typeof OrganizationKeyDossierIdDossierIndexRoute
  OrganizationKeyDossierIdProtocol_subscriptionsIndexRoute: typeof OrganizationKeyDossierIdProtocol_subscriptionsIndexRoute
  OrganizationKeyDossierIdQuestionnairesIndexRoute: typeof OrganizationKeyDossierIdQuestionnairesIndexRoute
  OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRoute: typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRoute
  OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRoute: typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRoute
  OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRoute: typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRoute
  OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRoute: typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRoute
  OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRoute: typeof OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRoute
  OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRoute: typeof OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRoute
  OrganizationKeyDossierIdNon_responsesShowNonResponseIdRoute: typeof OrganizationKeyDossierIdNon_responsesShowNonResponseIdRoute
  OrganizationKeyDossierIdNotificationsShowNotificationIdRoute: typeof OrganizationKeyDossierIdNotificationsShowNotificationIdRoute
  OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRoute: typeof OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRoute
  OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRoute: typeof OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRoute
  OrganizationKeyDossierIdReportsShowReportIdRoute: typeof OrganizationKeyDossierIdReportsShowReportIdRoute
  OrganizationKeyDossierIdReportsNewIndexRoute: typeof OrganizationKeyDossierIdReportsNewIndexRoute
  OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRoute: typeof OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRoute
  OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRoute: typeof OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRoute
  OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRoute: typeof OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRoute
  OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRoute: typeof OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRoute
}

const OrganizationKeyDossierIdRouteChildren: OrganizationKeyDossierIdRouteChildren =
  {
    OrganizationKeyDossierIdAnnouncementsRoute:
      OrganizationKeyDossierIdAnnouncementsRoute,
    OrganizationKeyDossierIdLab_test_resultsRoute:
      OrganizationKeyDossierIdLab_test_resultsRoute,
    OrganizationKeyDossierIdMeasureRoute: OrganizationKeyDossierIdMeasureRoute,
    OrganizationKeyDossierIdPendingRoute: OrganizationKeyDossierIdPendingRoute,
    OrganizationKeyDossierIdPreferencesRoute:
      OrganizationKeyDossierIdPreferencesRoute,
    OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRoute:
      OrganizationKeyDossierIdSelf_initiable_measured_questionnairesRoute,
    OrganizationKeyDossierIdIndexRoute: OrganizationKeyDossierIdIndexRoute,
    OrganizationKeyDossierIdDesignColorsRoute:
      OrganizationKeyDossierIdDesignColorsRoute,
    OrganizationKeyDossierIdDesignComponentsRoute:
      OrganizationKeyDossierIdDesignComponentsRoute,
    OrganizationKeyDossierIdDesignFormsRoute:
      OrganizationKeyDossierIdDesignFormsRoute,
    OrganizationKeyDossierIdDossierDemographicsRoute:
      OrganizationKeyDossierIdDossierDemographicsRoute,
    OrganizationKeyDossierIdDossierMetadataRoute:
      OrganizationKeyDossierIdDossierMetadataRoute,
    OrganizationKeyDossierIdNotificationsNewRoute:
      OrganizationKeyDossierIdNotificationsNewRoute,
    OrganizationKeyDossierIdOutcomeQuestionnaireIdRoute:
      OrganizationKeyDossierIdOutcomeQuestionnaireIdRouteWithChildren,
    OrganizationKeyDossierIdProtocol_subscriptionsStoppedRoute:
      OrganizationKeyDossierIdProtocol_subscriptionsStoppedRoute,
    OrganizationKeyDossierIdDesignIndexRoute:
      OrganizationKeyDossierIdDesignIndexRoute,
    OrganizationKeyDossierIdDossierIndexRoute:
      OrganizationKeyDossierIdDossierIndexRoute,
    OrganizationKeyDossierIdProtocol_subscriptionsIndexRoute:
      OrganizationKeyDossierIdProtocol_subscriptionsIndexRoute,
    OrganizationKeyDossierIdQuestionnairesIndexRoute:
      OrganizationKeyDossierIdQuestionnairesIndexRoute,
    OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRoute:
      OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_directRoute,
    OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRoute:
      OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_requestRoute,
    OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRoute:
      OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_fill_out_sessionRoute,
    OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRoute:
      OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_non_responseRoute,
    OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRoute:
      OrganizationKeyDossierIdFill_out_wizardMeasurementIdCreate_self_initiable_measured_questionnairesRoute,
    OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRoute:
      OrganizationKeyDossierIdFill_out_wizard_newMeasurementIdChooseRoute,
    OrganizationKeyDossierIdNon_responsesShowNonResponseIdRoute:
      OrganizationKeyDossierIdNon_responsesShowNonResponseIdRoute,
    OrganizationKeyDossierIdNotificationsShowNotificationIdRoute:
      OrganizationKeyDossierIdNotificationsShowNotificationIdRoute,
    OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRoute:
      OrganizationKeyDossierIdProtocol_subscriptionsNewAutoProtocolIdRoute,
    OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRoute:
      OrganizationKeyDossierIdQuestionnairesShowQuestionnaireIdRoute,
    OrganizationKeyDossierIdReportsShowReportIdRoute:
      OrganizationKeyDossierIdReportsShowReportIdRoute,
    OrganizationKeyDossierIdReportsNewIndexRoute:
      OrganizationKeyDossierIdReportsNewIndexRoute,
    OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRoute:
      OrganizationKeyDossierIdDossierRespondentsRespondentIdManageLoginRoute,
    OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRoute:
      OrganizationKeyDossierIdReportsNewReportTemplateIdPreviewRoute,
    OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRoute:
      OrganizationKeyDossierIdDossierRespondentsRespondentIdIndexRoute,
    OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRoute:
      OrganizationKeyDossierIdReportsNewReportTemplateIdIndexRoute,
  }

const OrganizationKeyDossierIdRouteWithChildren =
  OrganizationKeyDossierIdRoute._addFileChildren(
    OrganizationKeyDossierIdRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  NotLoggedInRoute: NotLoggedInRoute,
  OrganizationKeyDossierIdRoute: OrganizationKeyDossierIdRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
